export default __webpack_public_path__ + "static/media/fabula_desk_banner_1.36f6c2e3.png";